module.exports = __webpack_public_path__ + "78a45ea557ea6b55355a6dd390090d61.gif";